import React, { FC } from "react"
import { graphql } from "gatsby"

import { AccordionBlockFragmentFragment } from "@graphqlTypes"

import { generateConditionalClassName } from "@utils"

import LpSection from "@components/lp/LpSection/LpSection"

import AccordionList from "./components/AccordionList/AccordionList"
import AccordionListWithImages from "./components/AccordionListWithImages/AccordionListWithImages"
import { ACCORDION_SIZES } from "@components/Accordion/Accordion"

export enum CHECKMARK_VARIANT {
  DEFAULT = "None",
  POSITIVE = "Positive",
}

export enum MEDIA_POSITIONS {
  DEFAULT = "LEFT",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

const AccordionBlock: FC<AccordionBlockFragmentFragment & {
  accordionSize: ACCORDION_SIZES,
  useTextContainerWidth?: boolean,
}> = ({
  accordionSize = ACCORDION_SIZES.L,
  background,
  checkmark = CHECKMARK_VARIANT.DEFAULT,
  contentful_id,
  includeBackground,
  inlineTitle,
  items,
  marginBottom,
  mediaPosition = MEDIA_POSITIONS.DEFAULT,
  sectionText,
  title,
  useAutoAdvance,
  useDarkMode,
  useTextContainerWidth,
}) => {
    const hasImage =
      items && items.filter((item) => item?.image !== null).length > 0

    return (
      <LpSection
        background={background}
        className="AccordionBlock"
        includeBackground={includeBackground}
        marginBottom={marginBottom}
        title={title}
        text={sectionText}
        uniqueId={contentful_id}
        useDarkMode={useDarkMode}
      >
        <div className="container">
          <div className={(!hasImage && useTextContainerWidth) ? "" : "grid"}>
            {hasImage ? (
              <div className={generateConditionalClassName({
                "column column--1-7-XS column--2-12-M": true,
                "column--1-13-L": !useTextContainerWidth
              })}>
                <AccordionListWithImages
                  items={items}
                  title={inlineTitle || ""}
                  mediaPosition={mediaPosition as MEDIA_POSITIONS}
                  useAutoAdvance={useAutoAdvance}
                />
              </div>
            ) : (
              <div className={useTextContainerWidth ? "text-container" : "column column--1-7-XS column--2-12-M column--3-11-L"}>
                <AccordionList
                  items={items}
                  checkmark={checkmark as string}
                  size={accordionSize}
                />
              </div>
            )}
          </div>
        </div>
      </LpSection>
    )
  }

export const AccordionBlockFragment = graphql`
  fragment AccordionBlockFragment on ContentfulLpAccordionBlock {
    contentful_id
    title
    sectionText {
      raw
    }
    # inlineText {
    #   raw
    # }
    inlineTitle
    checkmark
    mediaPosition
    useAutoAdvance
    background
    includeBackground
    marginBottom
    useDarkMode
    items {
      ...AccordionItemMediaFragment
      textLinkText
      textLinkUrl
      title
      content {
        raw
      }
    }
  }
`

export default AccordionBlock
